import { autoinject } from "aurelia-framework";
import { bindable } from "aurelia-templating";
import { transient } from "aurelia-dependency-injection";

//Load styles
require("./comp-notify.scss");

@autoinject
@transient()
export class CompNotify {

    @bindable
    public icon: string;

    @bindable
    public type: "info" | "warning" | "danger" | "success";
}